module.exports = __webpack_public_path__ + "img/icon-flag-slovenia.cd63ba85.png";